import React, { useEffect, useRef } from 'react';
import './css/app1.css';

import logo1 from './logos/final/logo-01.png';
import logo2 from './logos/final/logo-02.png';
import logo3 from './logos/final/logo-03.png';
import logo4 from './logos/final/logo-04.png';
import logo5 from './logos/final/logo-05.png';
import logo6 from './logos/final/logo-06.png';
import logo7 from './logos/final/logo-07.png';
import logo8 from './logos/final/logo-08.png';
import logo9 from './logos/final/logo-09.png';
import logo10 from './logos/final/logo-10.png';
import logo11 from './logos/final/logo-11.png';
import logo12 from './logos/final/logo-12.png';
import logo13 from './logos/final/logo-13.png';
import logo14 from './logos/final/logo-14.png';
import logo15 from './logos/final/logo-15.png';

export default function OurClient() {
  const clientSectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show-animation');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const section = clientSectionRef.current;
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  const logos = [
    logo1, logo2, logo3, logo4, logo5,
    logo6, logo7, logo8, logo9, logo10,
    logo11, logo12, logo13, logo14, logo15
  ];

  return (
    <>
      <section ref={clientSectionRef} className="our-clients scroll-animation">
        <div className="row section-main-headingsec">
          <div className="col-md-12">
            <div id="ourclientheading" className="main-heading-text">
              <h2>OUR CLIENTS</h2>
            </div>

            <div className="row section-main-cliemts-logo">
              {logos.map((logo, index) => (
                <div className="col-md-2" key={index}>
                  <img src={logo} alt={`Client ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
